import axios from "axios";

export default function getBranchListByProduct({ payload }) {
  return new Promise((resolve, reject) =>
    axios
      .get("/serialnumber/system-admin/api/v1/products/nodes", {
        params: {
          productUuid: payload.productUuid,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
